import { useEffect, useId, useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { ENV_VARS } from 'app/config/environment-vars';
import { useUserEmail } from 'state/appState/appStateHooks';
import { SignalRActions } from 'state/signalr/SignalRActions';

export const useSignalRActions = () => {
  const history = useHistory();
  const userEmail = useUserEmail();
  const queryClient = useQueryClient();

  const dataHubUrl = ENV_VARS.SIGNALR_URL;

  const id = useId();

  const signalRActions = useMemo(() => {
    return new SignalRActions(id, userEmail, history, dataHubUrl, queryClient);
  }, [id, dataHubUrl, history, userEmail, queryClient]);

  useEffect(() => {
    signalRActions?.Connect();
    // signalRActions keeps track of all the usage of signalR in the app.
    // It only disconnects if there are no more usage of signalR.
    // However, we still encounter random disconnection issues.
    // Comment out the cleanup function in order to observe if the issue still persists.
    // TODO: restore the cleanup function if the issue still persists.

    //return () => {
    //   signalRActions?.Disconnect();
    //};
  }, [signalRActions]);

  return signalRActions;
};
